module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lX2FE"))).then(() => parcelRequire('5erN3'));